import cn from "classnames";
import {
  Card,
  CardContentWithLabels,
  CardHeader,
  P,
  CardContent,
} from "src/components";
import { getDateLabel, renderTestId } from "src/utils/HelperFunctions";
import { useCard } from "src/store/slices/cardsSlice";
import { cardConfig } from "src/utils/constants/CardConfig";
import { getCardOrEmptyState } from "src/utils/transformers/cardDataTransformer";

const CARD_ID = "cb398bf0-0e2b-47af-a017-7cbe156d80e1";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  span?: 2 | 4;
  cardVariant?: "default" | "secondary";
  customErrorMessage?: string;
}

const OpenBidsCard: React.FC<Props> = ({
  span = 4,
  cardVariant = "default",
  customErrorMessage,
}) => {
  const { isEmpty, card, isNotLoaded } = getCardOrEmptyState(
    CARD_ID,
    useCard(CARD_ID)
  );

  return (
    <>
      <Card
        variant={cardVariant}
        {...renderTestId(cardConfig[CARD_ID].testId)}
        header={
          <CardHeader
            title={cardConfig[CARD_ID].title}
            subtitle={
              <div className={cn("flex", "items-center", "gap-0.5")}>
                <P className={cn("text-xs", "font-400", "opacity-70")}>
                  Frissítve
                </P>
                <P className={cn("text-xs", "font-500", "opacity-80")}>
                  {getDateLabel(card?.updatedAt)}
                </P>
              </div>
            }
            info={cardConfig[CARD_ID].infoText}
            icon={cardConfig[CARD_ID].icon}
          />
        }
        content={
          <CardContent
            customErrorMessage={customErrorMessage}
            isLocked={false}
            isEmpty={isEmpty}
            isNotLoaded={isNotLoaded}
          >
            <CardContentWithLabels
              data={card?.data}
              span={span}
              isLocked={false}
              isEmpty={isEmpty}
              className="p-4"
            />
          </CardContent>
        }
        isEmpty={isEmpty}
      />
    </>
  );
};

export default OpenBidsCard;
